export default "__VITE_IMAGE_ASSET__9304a28c__";